import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'

Vue.use(Vuex);

//创建Vuex实例
const store = new Vuex.Store({
  state: {
    api: {//api链接
      //common: 'https://e-test.giant.com.cn/',//接口
      ev_api: 'https://appapi-test.giantev.com.cn/',//电动车接口 新宇、小唐
      qrcode_ev_api: 'https://giantqrcode.kssina.com/giantQRcode/',//电动车接口 小唐
      insurance_api: 'https://insure-gw-test.giant.com.cn/api.php/',//保险接口 晓娟
      rescue_api: 'https://opo-test.giant.com.cn/opo/index.php/',//道路救援 邹刚
      pay_api: 'https://pay-test.giant.com.cn/index.php/',//支付 邹刚

      login_api: 'https://appapi-test.giantev.com.cn/',//登录接口
      //admin: 'https://e-new-test.giant.com.cn/admin.php/',//后台接口，上传图片用
      gateway_api: 'https://gateway-test.giant.com.cn/giantService',
    },
    externalurl: {//外部链接
      opo: 'https://opo-test.giant.com.cn',
      banner: 'https://opo-test.giant.com.cn/opo/index.php/api/get_app_banner_list',
      chat: 'https://chat-test.giant.com.cn',
      insurance: 'https://insure-test.giant.com.cn',//保险中台
      qrcode: 'https://qrcode-test.giant.com.cn',
      common_sso_jump: 'https://dlinesso-test.giant.com.cn/index.php/api/app_sso_login?token=',//单点登录智能跳转 &url=
    },

    DLINE_ENVIRONMENT: true,//true 测试环境 false 正式环境

    loginUser: {},//登录用户信息

    bikeNow: false,//当前的车

    bikegeterror: false,//

    gettoken: false,//

    sendCode: false,//

    equipment: true,//

    browser: (function (ua) {
      var a = new Object();
      var b = {
        //micromessenger: /micromessenger/.test(ua),
        msie: /msie/.test(ua) && !/opera/.test(ua),
        opera: /opera/.test(ua),
        safari: /webkit/.test(ua) && !/chrome/.test(ua),
        firefox: /firefox/.test(ua),
        edge: /edge/.test(ua),
        trident: /trident/.test(ua),
        chrome: /chrome/.test(ua)
      };
      var vMark = "";
      for (var i in b) {
        if (b[i]) { vMark = i; break; }//"safari" == i ? "version" : i;
      }
      b.version = vMark && RegExp("(?:" + vMark + ")[\\/: ]([\\d.]+)").test(ua) ? RegExp.$1 : "0";
      b.ie = b.msie;
      b.ie6 = b.msie && parseInt(b.version, 10) == 6;
      b.ie7 = b.msie && parseInt(b.version, 10) == 7;
      b.ie8 = b.msie && parseInt(b.version, 10) == 8;

      //if(vMark == "trident") vMark = "ie11";

      a.b = vMark;
      a.v = b.version;
      a.m = /mobile/i.test(ua);
      a.wx = /MicroMessenger/i.test(ua);
      a.wxminiprogram = /miniProgram/i.test(ua);
      a.giantapp = /giantapp/i.test(ua);
      a.giantevapp = /giantevapp/i.test(ua);
      a.ios = /\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(ua);
      a.huawei=/huawei/i.test(ua);
      a.honor=/honor/i.test(ua);
      return a;
      
    })(window.navigator.userAgent.toLowerCase()),
    
  },
  getters: {//相当于计算属性
    // themeheaderBgSrc(state){
    //   if( typeof state.theme == 'object' && state.theme ){
    //     if( state.theme.headerBgSrc && state.theme.headerBgSrc.indexOf('linear-gradient') != -1 ){
    //       return state.theme.headerBgSrc;
    //     } else if(state.theme.headerBgSrc) {
    //       return 'url('+ state.theme.headerBgSrc +')';
    //     } else {
    //       return '';
    //     }
    //   } else {
    //     return '';
    //   }
    // },
  },
  mutations: {//逻辑处理，同步
    updateState( state, data ){//通用修改值
      state[data.label] = data.data;
    },
    changeApi(state, n) {//改变api链接
      if (n) {
        for (const key in n) {
          if (n.hasOwnProperty(key)) {
            state.api[key] = n[key]
          }
        }
      }
    },
    changeExternalurl(state, n) {//改变外部链接
      if (n) {
        for (const key in n) {
          if (n.hasOwnProperty(key)) {
            state.externalurl[key] = n[key]
          }
        }
      }
    },
    changeEnvironment(state) {//正式环境撤掉“测试”标志
      state.DLINE_ENVIRONMENT = false;
    },
    changeCartCount(state, n) {//修改购物车内商品数量
      state.cartCount = n;
    },

    // updateTheme( state, n ) {//更新主题皮肤数据
    //   state.theme = {};
    //   for( let k in n ){
    //     state.theme[k] = n[k];//.toString();
    //   }
    // },

    // updateBrandList( state, n ) {//更新品牌
    //   state.brandList = n;
    // },

    updateLoginUser(state, data) {//修改登录用户数据
      state.loginUser = data;
    },

    updateBikeNow( state, data ){//切换当前的车
      state.bikeNow = data;
    },
    updateerror( state, data ){//
      state.bikegeterror = data;
    },
    updatetoken( state, data ){//
      state.gettoken = data;
    },
    updatesendCode( state, data ){//
      state.sendCode = data;
    },
    updateequipment( state, data ){//
      state.equipment = data;
    },




  },
  actions: {//类似 mothods，异步

  }
});

//正式环境
if (window.location.host == 'service.giantev.com.cn') {
  store.commit('changeApi', { 
    //common: 'https://e.giant.com.cn/',
    insurance_api:'https://insure-gw.giant.com.cn/api.php/',
    rescue_api:'https://opo.giant.com.cn/opo/index.php/',
    pay_api:'https://pay.giant.com.cn/index.php/',
    ev_api: 'https://appapi.giantev.com.cn/',
    qrcode_ev_api: 'https://qrgiant.com/',//电动车接口 小唐
    login_api: 'https://appapi.giantev.com.cn/',//登录接口
    gateway_api: 'https://gateway.giant.com.cn/giantService',
  });
  store.commit('changeExternalurl', {
    opo: 'https://opo.giant.com.cn',
    banner: 'https://opo.giant.com.cn/opo/index.php/api/get_app_banner_list',
    chat: 'https://chat.giant.com.cn',
    insurance: 'https://insure.giant.com.cn',//保险
    qrcode: 'https://qrcode.giant.com.cn/web',
    common_sso_jump: 'https://dlinesso.giant.com.cn/index.php/api/app_sso_login?token=',
  });
  store.commit('changeEnvironment',false);
}



//导出store
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js